<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
              <li *ngIf="checkOVRInAgencyCode==='false'"  routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
              <li *ngIf="checkOVRInAgencyCode==='false'"  (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive=='false' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
              <li *ngIf="checkOVRInAgencyCode==='false'" class="active" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
              <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
              <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
              <li (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
              <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
              <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
              <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
      <div class="whitebox p-3">
          <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search</label>
          <label class="bold fs-20 m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
          <label class="bold fs-18 m-0 cp" (click)="backToPolicyDetails()">{{policyNumber}}</label>
          <label class="bold fs-20 txt-red m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
          <label class="bold fs-18 txt-red m-0">Refund Policy</label>
      </div>
      <div class="p-3">
          <!-- <label class="bold fs-16 txt-black">REFUND POLICY</label>
    <div class="clear5"></div>
    <div class="border-bottom"></div>
    <div class="clear10"></div>
    <label class="regular fs-16 txt-lightgrey">Please enter reason for refund</label>
    <div class="row">
        <textarea rows=4 class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12 textarea" [(ngModel)]="refundPolicyReason" (input)="removeRefundError()"></textarea>
    </div>
    <p class="dateSubtxt1 red" *ngIf="showReasonError">Reason is required</p>
    <div class="clear10"></div>
    <button type="button" class="btn-upload"  *ngIf="policyStatus!='Refunded'" (click)="onRefundProcessCall()">Process Refund</button>
    <button type="button" class="btn-upload op05" *ngIf="policyStatus=='Refunded'" disabled>Process Refund</button>
    <div class="clear10"></div>
    <div class="border-bottom"></div>
    <div class="clear10"></div> -->
          <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                  <div class="row">
                      <div class="col-sm-2 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-black ">Admin Fee Amount <span class="redstar">*</span></label>
                      </div>
                      <!-- <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                          <label class="italic fs-14 txt-black">(Select a fee from the list, or enter a value in the
                              text box)</label>
                      </div> -->
                  </div>
                  <div class="row ">
                      <ng-select placeholder="Select" class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12" [(ngModel)]="adminFee" (ngModelChange)="onadminFeeClick()">
                          <ng-option selected value="0">$0</ng-option>
                          <!-- <ng-option value="10">$10</ng-option> -->
                          <ng-option value="25">$25</ng-option>
                          <ng-option value="50">$50</ng-option>
                      </ng-select>
                      <!-- <label class="col-lg-1 col-xl-1 regular fs-14 text-center">or</label>
                      <input type="text" placeholder="Type here"
                          class=" form-control forminput1 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12"> -->
                  </div>
                  <p class="dateSubtxt1 redstar"  *ngIf="adminfeeerror">'Admin fee' is required.</p>
              </div>
          </div>
          <div class="clear20"></div>
          <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                  <label class="regular fs-14 txt-black textcolor">Please enter reason for refund <span class="redstar">*</span></label>
                  <div>
                      <textarea rows="3" class="textarea regular col-sm-9 col-md-9 col-lg-9 col-xl-9 col-12" [(ngModel)]="adminFeeReason" (input)="onadminFeeReasonClick()"
                          placeholder="Type here"></textarea>
                  </div>
                   <p class="dateSubtxt1 redstar"  *ngIf="adminFeeReasonerror">'Reason for refund' is required.</p>

              </div>
          </div>
          <div class="clear10"></div>
          <div class="border-bottom"></div>
          <div class="clear10"></div>
               <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                      <label class="bold fs-16">Enter Payment &nbsp;&nbsp;</label> <span
                       class="regular fs-14 txt-lightblack2">(Note: Lines with no amount will be ignored)</span>
              </div>
                  <div class="clear5"></div>
                  <div class="border-bottom"></div>
                  <div class="clear5"></div>

                  <!-- <label class="bold fs-14 txt-red">Payment: 1</label> -->
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <label class="regular fs-14 txt-black">Total Amount</label>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Payment Type</label>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Card Number</label>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <label class="regular fs-14 txt-black">CVV</label>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Expiry (mm/yy)</label>
                    </div>
                  </div>
                  <div class="clear5"></div>
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <div class="mb-3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount" >
                    </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType1" (ngModelChange)="changePaymentType(cardType1)">
                        <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                        <!-- <ng-option  value="">{{ssl_card_number}}</ng-option> -->
                          <!-- <ng-option value="VISA">Visa</ng-option> -->
                          <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                          <!-- <ng-option value="MasterCard">Master Card</ng-option>
                          <ng-option value="AmericanExpress">American Express</ng-option> -->
                      </ng-select>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showCardNo1">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber1" maxlength="16">
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <div class="mb-3" *ngIf="showCVV1">
                        <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv1"  maxlength="3">
                      </div>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showexp1">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate1"  maxlength="5" (input)="CCExpdate1()">
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <div class="mb-3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount2" >
                    </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType2" (ngModelChange)="changePaymentType2(cardType2)">
                        <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                        <!-- <ng-option  value="">{{ssl_card_number}}</ng-option> -->
                          <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                          <!-- <ng-option value="VISA">Visa</ng-option> -->
                          <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                          <!-- <ng-option value="MasterCard">Master Card</ng-option>
                          <ng-option value="AmericanExpress">American Express</ng-option> -->
                      </ng-select>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showCardNo2">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber2" maxlength="16">
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <div class="mb-3" *ngIf="showCVV2">
                        <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv2"  maxlength="3">
                      </div>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showexp2">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate2"  maxlength="5" (input)="CCExpdate2()">
                      </div>
                    </div>
                  </div>
                 
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <div class="mb-3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount3" >
                    </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType3" (ngModelChange)="changePaymentType3(cardType3)">
                        <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                        <!-- <ng-option  value="">{{ssl_card_number}}</ng-option> -->
                          <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                          <!-- <ng-option value="VISA">Visa</ng-option> -->
                          <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                          <!-- <ng-option value="MasterCard">Master Card</ng-option>
                          <ng-option value="AmericanExpress">American Express</ng-option> -->
                      </ng-select>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showCardNo3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber3" maxlength="16">
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <div class="mb-3" *ngIf="showCVV3">
                        <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv3"  maxlength="3">
                      </div>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showexp3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate3"  maxlength="5" (input)="CCExpdate3()">
                      </div>
                    </div>
                  </div>
                 
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <div class="mb-3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount4" >
                    </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType4" (ngModelChange)="changePaymentType4(cardType4)">
                        <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                        <!-- <ng-option  value="">{{ssl_card_number}}</ng-option> -->
                          <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                          <!-- <ng-option value="VISA">Visa</ng-option> -->
                          <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                          <!-- <ng-option value="MasterCard">Master Card</ng-option>
                          <ng-option value="AmericanExpress">American Express</ng-option> -->
                      </ng-select>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showCardNo4">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber4" maxlength="16">
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <div class="mb-3" *ngIf="showCVV4">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv4"  maxlength="3">
                      </div>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showexp4">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate4"  maxlength="5" (input)="CCExpdate4()">
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
                      <div class="mb-3">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount5" >
                    </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType5" (ngModelChange)="changePaymentType5(cardType5)">
                        <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                        <!-- <ng-option  value="">{{ssl_card_number}}</ng-option> -->
                          <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                          <!-- <ng-option value="VISA">Visa</ng-option> -->
                          <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                          <!-- <ng-option value="MasterCard">Master Card</ng-option>
                          <ng-option value="AmericanExpress">American Express</ng-option> -->
                      </ng-select>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showCardNo5">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber5" maxlength="16">
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
                      <div class="mb-3" *ngIf="showCVV5">
                        <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv5"  maxlength="3">
                      </div>
                    </div> -->
                    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                      <div class="mb-3" *ngIf="showexp5">
                        <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate5"  maxlength="5" (input)="CCExpdate5()">
                      </div>
                    </div>
                  </div>
          
          <div class="clear20"></div>
          <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
              <button type="submit" class="backbtn w100px mr-2 bold" (click)="backToPolicyDetails()">Go Back</button>
              <button type="button" class="btn-upload"  *ngIf="policyStatus!='Refunded' && cardexpdateFlagButtonDisable==false" (click)="onRefundProcessCall()">Process Refund</button>
    <button type="button" class="btn-upload op05" *ngIf="policyStatus=='Refunded'" disabled>Process Refund</button>
              </div>
          </div>
      <label class="bold fs-16 txt-black">Previous Payments</label>
    <div class="clear10"></div>
    <div class="tableheadFix">
        <table id="RefundPolicy" class="w100">
            <thead class="nowrap">
                <tr>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>Payment Date</span>
                        </div>
                    </th>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>TYPE</span>
                        </div>
                    </th>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>Amount</span>
                        </div>
                    </th>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>Card Number</span>
                        </div>
                    </th>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>Exp (mm/yy)</span>
                        </div>
                    </th>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>Card Processing</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="">
                <tr *ngFor="let item of policypaymentdetailsArray1;let i=index">
                    <td><span>{{item.transactionPaymentDetails[0].sslTxnTime | date:'ddMMMyyyy'}}</span></td>
                    <td>{{item.transactionPaymentDetails[0].sslCardType}}</td>
                    <td>{{item.transactionPaymentDetails[0].sslAmount}}</td>
                    <td>{{item.transactionPaymentDetails[0].sslCardNumber}}</td>
                    <td>{{item.transactionPaymentDetails[0].sslExpDate}}</td>
                    <td>{{item.transactionPaymentDetails[0].sslResultMessage}}</td>
                </tr>
            </tbody>
        </table>
    </div>
      </div>
  </div>
</div>
